<template>
<div class="fixed_module_container">
    <a-anchor class="anchor" @click="handleAnchor" :offsetTop="200" v-if="configs.length>=2 && $route.name!=='experience'" style="width: calc(50% - 750px)">
        <a-anchor-link v-for="comp in configs" :key="`anchor_${comp.id}`"
            :href="`#${comp.id}`" :title="$t(comp.title)"  />
    </a-anchor>
    <div :class="container_class" :style="this.$route.name==='test'?'width:auto;padding:0;':''">
        <template v-if="this.$route.name==='experience'">
            <a-tabs class="ux-exp-tabs" type="card">
                <a-tab-pane :key="comp.id" :tab="$t(comp.title)" v-for="comp in configs">
                    <component :key="`component_${comp.id}`" :id="comp.id"
                    :is="comp.ctrl" :title="$t(comp.title)" :api="comp.id" :fields="comp.fields" :chart="comp.chart" :conf="comp.conf"/>
                </a-tab-pane>
            </a-tabs>
        </template>
        <template v-else>
            <component v-for="comp in configs" :key="`component_${comp.id}`" :id="comp.id"
                :is="comp.ctrl" :title="$t(comp.title)" :api="comp.id" :fields="comp.fields" :chart="comp.chart" :conf="comp.conf" :searchers="comp.mod.searchers"/>
        </template>
    </div>
</div>
</template>
<script>
import moment from "moment";
import i18n from '@/locale/game';
import service from '@/utils/service'

const CONFIGS = {
    test: [{
        id: 'test_overview',
        title: '测试概览',
        component: 'testPanel',
    }],
    realtime: [
        {
            id:'realtime_overview', 
            title: i18n.t('fixed.realtime.overview.title'),
            component: 'overviewPanel',
            fields: [
                {id: 'pay', title: i18n.t('fixed.realtime.overview.dataPay'), tooltip:(proj)=>{if(proj==='lb2na') {return '充值包含游戏内充值和交易手续费'}}},
                {id: 'new', title: i18n.t('fixed.realtime.overview.dataNew')},
                {id: 'dau', title: i18n.t('fixed.realtime.overview.dataDau')},
            ],
            conf: {
                realtime: true,
                server: false,
                selected: 2,
            }
        },
        {
            id:'realtime_increase',
            component: 'comparePanel',
            title: "实时新增",
            chart: {
                fixed: true,
                type: 'line',
                x: {id: 'time', title: '时间', type:'cat', tickCount: 28},
                y: {id: 'new', title: '新增人数'},
                color: null,
                series: {id:'series'},
                label: false,
                slider: true,
                point: false,
                mark: true,
                other: {
                    legend: {
                        position: 'top-center'
                    }
                }
            },
        },
        {
            id: 'realtime_online',
            component: 'comparePanel',
            title: 'fixed.realtime.online.title',
            chart: {
                fixed: true,
                type: 'line',
                x: {id: 'time', title: i18n.t('common.timeU'), type:'cat', tickCount: 28},
                y: {id: 'online', title: i18n.t('fixed.realtime.online.cnt')},
                color: null,
                series: {id:'series'},
                label: false,
                slider: true,
                point: false,
                mark: true,
                other: {
                    legend: {
                        position: 'top-center'
                    }
                }
            }
        },
        {
            id: 'realtime_deviceonline',
            component: 'comparePanel',
            title: 'fixed.realtime.online.deviceTitle',
            chart: {
                fixed: true,
                type: 'line',
                x: {id: 'time', title: i18n.t('common.timeU'), type:'cat', tickCount: 28},
                y: {id: 'online', title: i18n.t('fixed.realtime.online.cnt')},
                color: null,
                series: { id:'os_name' },
                label: false,
                slider: true,
                point: false,
                mark: true,
                other: {
                    legend: {
                        position: 'top-center'
                    }
                }
            },
            conf: {
                type: 'device',
                showDateCompare: false,
            }
        },
        {
            id: 'realtime_udidconversion',
            component: 'udidPanel',
            title: i18n.t(`fixed.realtime.conversion.title`),
        }
    ],
    report: [
        {
            id:'report_overview', 
            title: '数据概览',
            component: 'reportPanel',
        },
    ],
    pay: [
        {
            id:'pay_overview', 
            component: 'overviewPanel',
            title: i18n.t(`fixed.pay.overview.title`),
            fields: [
                {id: 'cash', title:i18n.t(`fixed.pay.overview.dataCash`)},
                {id: 'pay_acc_cnt', title:i18n.t(`fixed.pay.overview.dataPayAccCnt`)},
                {id: 'pay_ratio', title:i18n.t(`fixed.pay.overview.dataPayRatio`), suffix:'%', decimal:2},
                {id: 'arpu', title:i18n.t(`fixed.pay.overview.dataArpu`), decimal:2},
            ],
            conf: {
                server: service.PROJ_CODE === 'ld1'?false:true,
            }
        },
        {
            id: 'pay_ltv',
            component: 'commonPanel',
            title: i18n.t(`fixed.pay.ltv.title`),
            fields: [
                    {id: 'dt', title: i18n.t(`common.date`), width:'15%'},
                    {id: 'acc_cnt', title: i18n.t(`fixed.pay.ltv.newAccCount`), width:'15%'},
                    {id: 'ltv1', title: i18n.t(`fixed.pay.ltv.ltv1`), width:'14%'},
                    {id: 'ltv3', title: i18n.t(`fixed.pay.ltv.ltv3`), width:'14%' },
                    {id: 'ltv7', title: i18n.t(`fixed.pay.ltv.ltv7`), width:'14%' },
                    {id: 'ltv15', title: i18n.t(`fixed.pay.ltv.ltv15`), width:'14%'},
                    {id: 'ltv30', title: i18n.t(`fixed.pay.ltv.ltv30`), width:'14%' },
            ],
            chart: {
                type: 'mixin',
                versionday: 'dt',
                x: {id: 'dt', title: i18n.t(`common.date`),},
                y: [
                    {id: 'acc_cnt', title: i18n.t(`fixed.pay.ltv.newAccCount`), type: 'interval', pos: 'l', color:'#E6F7FF'},
                    {id: 'ltv1', title: i18n.t(`fixed.pay.ltv.ltv1`), type: 'line', pos: 'r', color: '#1890FF'},
                    {id: 'ltv3', title: i18n.t(`fixed.pay.ltv.ltv3`), type: 'line', pos: 'r', color: '#FFAE28'},
                    {id: 'ltv7', title: i18n.t(`fixed.pay.ltv.ltv7`), type: 'line', pos: 'r', color: '#2FC25B'},
                    {id: 'ltv15', title: i18n.t(`fixed.pay.ltv.ltv15`), type: 'line', pos: 'r', color: '#223273', visible: false},
                    {id: 'ltv30', title: i18n.t(`fixed.pay.ltv.ltv30`), type: 'line', pos: 'r', color: '#8543E0', visible: false}],
                series: null,
                label: false,
                slider: false,
                yaxis: {
                    left: {title:i18n.t(`fixed.pay.ltv.accCount`), type:'bar',  color: ['#E6F7FF' , '#BAE7FF' , '#91D5FF' , '#69C0FF' , '#40A9FF' , '#1890FF' , '#096DD9' , '#0050B3' , '#003A8C' , '#002766'],},
                    right: {title:'LTV', type:'line'},
                },
                legend: false,
                other: {
                    tooltip: {
                        crosshairs: {style:{lineDash:[3]}, type:'y'}
                    },
                    legend: {
                        position: 'top-center'
                    },
                }
            },
            conf: {
                pre_handler: function(res_datas, chart) {
                    res_datas.forEach((row)=>{
                        row['ds'] = row.dt.slice(5)
                    })
                    chart.y.forEach((y)=>{
                        let empty = true
                        res_datas.forEach((row)=>{
                            if(row[y.id]!=null) {
                                empty = false
                            }
                        })
                        if(empty) {
                            y.visible = false
                        }
                        else {
                            y.visible = true
                        }
                    })
                    
                    if(res_datas.length > 14) {
                        chart.x.id = 'ds'
                    }
                    else {
                        chart.x.id = 'dt'
                    }
                    return res_datas
                },
                range: 13,
            }
        },
        {
            id: 'pay_vip',
            component: 'vipPanel',
            title: i18n.t('fixed.pay.structure.title'),
        }
    ],
    new: [
        {
            id:'new_overview', 
            component: 'overviewPanel',
            title: i18n.t(`fixed.new.overview.title`),
            fields: [
                {id: 'acc_cnt', title: i18n.t(`fixed.new.overview.dataAccCnt`)},
                {id: 'role_cnt', title: i18n.t(`fixed.new.overview.dataRoleCnt`)},
            ],
            conf: {
                server: true,
            }
        },
        {
            id:'new_liucun', 
            component: 'commonPanel',
            title: i18n.t(`fixed.new.liucun.title`),
            fields: [
                {id:'weekday', title:""}, 
                {id:'ds', title: i18n.t(`common.date`), class:"liucun_bold", download_id:'dt'}, 
                {id:"acc_cnt", title: i18n.t(`fixed.new.liucun.dataAccCnt`), class:"liucun_bold"}, 
                {id:"liucun1", title: i18n.t(`day.day_2`), suffix:"%", colorful:true}, 
                {id:"liucun2", title: i18n.t(`day.day_3`), suffix:"%", colorful:true}, 
                {id:"liucun3", title: i18n.t(`day.day_4`), suffix:"%", colorful:true}, 
                {id:"liucun4", title: i18n.t(`day.day_5`), suffix:"%", colorful:true}, 
                {id:"liucun5", title: i18n.t(`day.day_6`), suffix:"%", colorful:true}, 
                {id:"liucun6", title: i18n.t(`day.day_7`), suffix:"%", colorful:true}, 
                {id:"liucun7", title: i18n.t(`day.day_8`), suffix:"%", colorful:true}, 
                {id:"liucun8", title: i18n.t(`day.day_9`), suffix:"%", colorful:true}, 
                {id:"liucun9", title: i18n.t(`day.day_10`), suffix:"%", colorful:true}, 
                {id:"liucun10", title: i18n.t(`day.day_11`), suffix:"%", colorful:true}, 
                {id:"liucun11", title: i18n.t(`day.day_12`), suffix:"%", colorful:true}, 
                {id:"liucun12", title: i18n.t(`day.day_13`), suffix:"%", colorful:true}, 
                {id:"liucun13", title: i18n.t(`day.day_14`), suffix:"%", colorful:true}, 
                {id:"liucun14", title: i18n.t(`day.day_15`), suffix:"%", colorful:true}, 
                {id:"liucun29", title: i18n.t(`day.day_30`), suffix:"%", colorful:true}, 
            ],
            conf: {
                display: "table",
                nodisplay: true,
                server: true,
                range: 29,
                tabs: [
                    {id:"acc", name: i18n.t(`fixed.new.liucun.accTitle`)},
                    {id:"role", name: i18n.t(`fixed.new.liucun.roleTitle`)},
                ],
                table: {
                    class: 'new_liucun_table',
                    liucun: true,
                    page_size: 20,
                },
                tab_handler: (tab, fields) => {
                     fields[2]['title'] = tab =='acc' ? i18n.t(`fixed.new.liucun.dataAccCnt`) : i18n.t(`fixed.new.liucun.dataRoleCnt`)
                }
            }
        },
        {
            id:'new_weekliucun', 
            component: 'commonPanel',
            title: i18n.t(`fixed.new.week_liucun.title`),
            fields: [
                {id:'weeks', title: i18n.t(`fixed.new.week_liucun.week`), width: '200px'}, 
                {id:"new", title: i18n.t(`fixed.new.liucun.dataAccCnt`), }, 
                {id:"liucun_1", title: i18n.t(`fixed.new.week_liucun.week_1`), suffix:"%", colorful:true}, 
                {id:"liucun_2", title: i18n.t(`fixed.new.week_liucun.week_2`), suffix:"%", colorful:true}, 
                {id:"liucun_3", title: i18n.t(`fixed.new.week_liucun.week_3`), suffix:"%", colorful:true}, 
                {id:"liucun_4", title: i18n.t(`fixed.new.week_liucun.week_4`), suffix:"%", colorful:true}, 
                {id:"liucun_5", title: i18n.t(`fixed.new.week_liucun.week_5`), suffix:"%", colorful:true}, 
            ],
            conf: {
                display: "table",
                nodisplay: true,
                range: 90,
                table: {
                    class: 'new_liucun_table',
                    liucun: true,
                    page_size: 20,
                },
            }
        },
        {
            id: 'new_minutereach',
            component: 'commonPanel',
            title: service.PROJ_CODE === 'ld1'?'新增账号分钟到达率':i18n.t(`fixed.new.minuteReach.title`),
            fields: [
                {id:'minute', 'title': i18n.t(`fixed.new.min`), ticks:[0,5,15,30,60,90,120], type:'identity', 'suffix': i18n.t(`fixed.new.min`)},
                {id:'ratio', 'title': i18n.t(`fixed.new.minuteReach.ratio`), 'suffix': '%'}
            ],
            chart: {
                fixed: true,
                type: 'area',
                x: {id: 'minute', title: i18n.t(`fixed.new.minuteReach.min`), type:'linear', ticks:[0,5,15,30,60,90,120]},
                y: {id: 'ratio', title: i18n.t(`fixed.new.minuteReach.ratio`), suffix:'%'},
                color: ['#1890FF' , '#40A9FF' , '#69C0FF' , '#91D5FF' , '#BAE7FF' , '#E6F7FF' , '#096DD9' , '#0050B3' , '#003A8C' , '#002766'],
                series: {id:'series'},
                label: true,
                slider: false,
                legend: false,
                tooltip: false,
            },
            conf: {
                server: service.PROJ_CODE === 'ld1'?false:true,
                date: true,
                after_handler: function(res_data) {
                    return _.filter(res_data,(d)=> d.series==`${d.minute}分钟`);
                }
            }
        },
        {
            id: 'new_minutereachtrend',
            component: 'commonPanel',
            title: service.PROJ_CODE === 'ld1'?'新增账号分钟到达率趋势':i18n.t(`fixed.new.minuteReachTrend.title`),
            fields: [
                {id: 'dt', title: i18n.t(`common.date`)},
                {id: '5分钟', title: i18n.t(`fixed.new.minuteReachTrend.ratio_5`), suffix:'%'},
                {id: '15分钟', title: i18n.t(`fixed.new.minuteReachTrend.ratio_15`), suffix:'%'},
                {id: '30分钟', title: i18n.t(`fixed.new.minuteReachTrend.ratio_30`), suffix:'%'},
                {id: '60分钟', title: i18n.t(`fixed.new.minuteReachTrend.ratio_60`), suffix:'%'},
                {id: '90分钟', title: i18n.t(`fixed.new.minuteReachTrend.ratio_90`), suffix:'%'},
                {id: '120分钟', title: i18n.t(`fixed.new.minuteReachTrend.ratio_120`), suffix:'%'},
            ],
            chart: {
                type: 'line',
                versionday: 'dt',
                x: {id: 'dt', title: i18n.t(`common.date`)},
                y: {id: 'ratio', title: i18n.t(`fixed.new.minuteReachTrend.ratio`), suffix:'%'},
                color: null,
                series: {id:'seriesMinute'},
                label: false,
                slider: false,
                other: {
                    legend: {
                        position: 'top-center'
                    }
                }
            },
            conf: {
                server: service.PROJ_CODE === 'ld1'?false:true,
                pre_handler: function(res_datas) {
                    return (res_datas || []).map(rdata => ({
                        ...rdata,
                        seriesMinute: rdata.minute.replace(`分钟`, i18n.t(`fixed.new.min`)),
                    }));
                },
                after_handler: function(res_datas) {
                    let combine_datas = []
                    let group_datas = _.groupBy(res_datas, 'dt')
                    Object.keys(group_datas).forEach((dt)=>{
                        let combine_row = {'dt':dt}
                        group_datas[dt].forEach((row)=>{
                            combine_row[row.minute] = row.ratio
                        })
                        combine_datas.push(combine_row)
                    })
                    return combine_datas
                },
            }
        }
    ],
    online: [
        {
            id:'online_overview', 
            component: 'overviewPanel',
            title: i18n.t(`fixed.online.overview.title`),
            fields: [
                {id: 'acc_cnt', title: i18n.t(`fixed.online.overview.dataAccCnt`), },
                {id: 'udid_cnt', title: i18n.t(`fixed.online.overview.dataDeviceCnt`), },
                {id: 'role_cnt', title: i18n.t(`fixed.online.overview.dataRoleCnt`), },
            ],
            conf: {
                server: true,
            }
        },
        {
            id: 'online_online',
            component: 'comparePanel',
            title: i18n.t(`fixed.online.online.title`),
            chart: {
                fixed: true,
                type: 'line',
                x: {id: 'time', title: i18n.t(`fixed.online.online.time`), type:'inherit', tickCount:17},
                y: {id: 'online', title: i18n.t(`fixed.online.online.cnt`)},
                color: null,
                series: {id:'series'},
                label: false,
                slider: true,
                point: false,
                other: {
                    legend: {
                        position: 'top-center',
                    }
                }
            }
        },
        {
            id: 'online_leveldistribution',
            component: 'commonPanel',
            title: i18n.t(`fixed.online.level.title`),
            fields: [
                {id:'role_level', title: i18n.t(`fixed.online.level.level`), width:'50%'}, 
                {id:"cnt", title: i18n.t(`fixed.online.cnt`), width:'50%'}, 
            ],
            chart: {
                fixed: true,
                type: 'bar',
                x: {id: 'role_level', title: i18n.t(`fixed.online.level.level`)},
                y: {id: 'cnt', title: i18n.t(`fixed.online.cnt`)},
                color: null,
                series: null,
                label: false,
                slider: false,
            },
            conf: {
                server: true,
                date: true,
            }
        },
        {
            id: 'online_classdistribution',
            component: 'commonPanel',
            title: i18n.t(`fixed.online.class.title`),
            fields: [
                {id:'role_class', title: i18n.t(`fixed.online.class.class`), width:'50%'}, 
                {id:"cnt", title: i18n.t(`fixed.online.cnt`), width:'50%'}, 
            ],
            chart: {
                fixed: true,
                type: 'bar',
                x: {id: 'role_class', title: i18n.t(`fixed.online.class.class`)},
                y: {id: 'cnt', title: i18n.t(`fixed.online.cnt`)},
                color: null,
                series: null,
                label: false,
                slider: false,
            },
            conf: {
                server: true,
                date: true,
            }
        },
        {
            id: 'online_dau',
            component: 'mapPanel',
            title: i18n.t(`fixed.online.map.title`),
            fields:  [
                {id:'name', title: i18n.t(`fixed.online.map.area`), width:'50%'},
                {id:'value', title: i18n.t(`fixed.online.cnt`), width:'50%'},
            ],
            conf: {
                server: true,
                date: true,
            }
        }
    ],
    version: [
        {
            id:'version_ing', 
            title: '进行中',
            component: 'versionPanel',
            fields: [
                {id: 'version_name', title:'名称', width:'19%'}, 
                {id: 'start_date', title: '开始日期', width:'7%', sorter:true},
                {id: 'start_days', title: '开启至今', width:'7%', suffix:'天', sorter:true},
                {id: 'days', title: '版本周期', width:'7%', suffix:'天', sorter:true},
                {id: 'total_pay', title: '总付费数(元)', width:'9%', sorter:true},
                {id: 'total_pay_account', title: '总付费账号数', width:'9%', sorter:true},
                {id: 'arpu', title: '人均每日付费(元)', width:'11%', sorter:true},
                {id: 'total_account', title: '总登录账号数', width:'9%', sorter:true},
                {id: 'huiliu_num', title: '回流总数', width:'7%', sorter:true},
                {id: 'total_new', title: '总新增账号数', width:'9%', sorter:true},
            ],
            conf: {
                title: "活动/资料片监测(进行中)"
            }
        },
        {
            id:'version_history', 
            title: '已结束',
            component: 'versionPanel',
            fields: [
                {id: 'version_name', title:'名称', width:'19%'}, 
                {id: 'start_date', title: '开始日期', width:'7%', sorter:true},
                {id: 'end_date', title: '结束日期', width:'7%', sorter:true},
                {id: 'days', title: '版本周期', width:'7%', suffix:'天', sorter:true},
                {id: 'total_pay', title: '总付费数(元)', width:'9%', sorter:true},
                {id: 'total_pay_account', title: '总付费账号数', width:'9%', sorter:true},
                {id: 'arpu', title: '人均每日付费(元)', width:'11%', sorter:true},
                {id: 'total_account', title: '总登录账号数', width:'9%', sorter:true},
                {id: 'huiliu_num', title: '回流总数', width:'7%', sorter:true},
                {id: 'total_new', title: '总新增账号数', width:'9%', sorter:true},
                {id: 'liushi_rate', title: '流失率', suffix:'%', width:'6%', sorter:true},
            ],
            conf: {
                title: "历次活动/资料片信息(已结束)"
            }
        },
    ],
    consume: [
        {
            id:'consume_coin', 
            title: '消费专题',
            component: 'consumePanel',
        },
    ],
    reflow: [
        {
            id:'reflow_overview', 
            component: 'overviewPanel',
            title: '回流数据概览',
            fields: [
                {id: 'reflow_cnt_7', title:'7日回流账号'},
                {id: 'reflow_cnt_15', title:'15日回流账号'},
                {id: 'reflow_cnt_30', title:'30日回流账号'},
            ],
            conf: {
                server: true,
            }
        },
        {
            id:'reflow_liucun', 
            component: 'commonPanel',
            title: '7/15/30日回流留存',
            fields: [
                {id:'weekday', title:""}, 
                {id:'ds', title:"日期", class:"liucun_bold", download_id:'dt'}, 
                {id:"acc_cnt", title:"7日回流账号", class:"liucun_bold"}, 
                {id:"liucun1", title:"次日", suffix:"%", colorful:true}, 
                {id:"liucun2", title:"第3日", suffix:"%", colorful:true}, 
                {id:"liucun3", title:"第4日", suffix:"%", colorful:true}, 
                {id:"liucun4", title:"第5日", suffix:"%", colorful:true}, 
                {id:"liucun5", title:"第6日", suffix:"%", colorful:true}, 
                {id:"liucun6", title:"第7日", suffix:"%", colorful:true}, 
                {id:"liucun7", title:"第8日", suffix:"%", colorful:true}, 
                {id:"liucun8", title:"第9日", suffix:"%", colorful:true}, 
                {id:"liucun9", title:"第10日", suffix:"%", colorful:true}, 
                {id:"liucun10", title:"第11日", suffix:"%", colorful:true}, 
                {id:"liucun11", title:"第12日", suffix:"%", colorful:true}, 
                {id:"liucun12", title:"第13日", suffix:"%", colorful:true}, 
                {id:"liucun13", title:"第14日", suffix:"%", colorful:true}, 
                {id:"liucun14", title:"第15日", suffix:"%", colorful:true}, 
                {id:"liucun29", title:"第30日", suffix:"%", colorful:true}, 
            ],
            conf: {
                display: "table",
                nodisplay: true,
                server: true,
                range: 29,
                tabs: [
                    {id:"7", name:"7日回流账号"},
                    {id:"15", name:"15日回流账号"},
                    {id:"30", name:"30日回流账号"},
                ],
                table: {
                    class: 'new_liucun_table',
                    liucun: true,
                    page_size: 20,
                },
                tab_handler: (tab, fields) => {
                     fields[2]['title'] = tab =='7'?'7日回流账号': tab =='15'? '15日回流账号' : '30日回流账号'
                }
            }
        },
    ],
    experience: [{
        id: 'experience_overview',
        title: '测试评分',
        component: 'uxExperiencePanel',
    }, {
        id: 'experience_eye',
        title: '眼动测试',
        component: 'uxExperienceEyePanel',
    }, {
        id: 'experience_gameplay',
        title: 'UGC玩法测试得分',
        component: 'uxExperience/uxUGCGameplayPanel'
    }, {
        id: 'experience_grouptest',
        title: 'UGC玩法XGP群测得分',
        component: 'uxExperience/uxUGCGameplayGroupTestPanel'
    },{
        id: 'experience_issue',
        title: '问题清单',
        component: 'uxExperience/uxIssuePanel'
    }, {
        id: 'experience_ugc',
        title: 'UGC对比测试',
        component: 'uxExperience/uxUGCPanel'
    }, ],
    veteran: [{
        id: 'veteran_overview',
        title: '历史玩家挖掘',
        component: 'veteranPanel'
    }],
    fashion: [{
        id: 'fashion_overview',
        title: '时尚趋势',
        component: 'fashionPanel'
    }]    
}

const today = moment()
const yesterday = moment(today).subtract(1, 'day')
const ranges = {
    '过去7天': [moment(yesterday).subtract(6, 'day'), moment(yesterday)],
    '过去14天': [moment(yesterday).subtract(13, 'day'), moment(yesterday)],
    '过去28天': [moment(yesterday).subtract(27, 'day'), moment(yesterday)],
    '过去42天': [moment(yesterday).subtract(41, 'day'), moment(yesterday)],
    '本周': [moment(today).startOf('week'), moment(today).endOf('week')],
    '本月': [moment(today).startOf('month'), moment(today).endOf('month')],
}

export default {
    components: {},
    provide: {
        today,
        yesterday,
        ranges: i18n.locale === 'en_US'?{}:ranges,
    },
    data() {
        return {
        }
    },
    computed: {
        configs() {
            let _configs = []
            if(CONFIGS[this.$route.name]) {
                CONFIGS[this.$route.name].forEach(c=>{
                    if(this.submodules[c.id]) {
                        let _config = Object.assign({mod: this.submodules[c.id]}, c)
                        _config.ctrl = require(`@/components/game/fixed/${c.component}.vue`).default
                        _configs.push(_config)
                    }
                })
            }
            return _configs
        },
        submodules() {
            let m = this.$store.getters.getModule(this.$route.meta.id)
            if(m && m.sub) {
                let subs = {}
                m.sub.forEach((s)=>{
                    const _s = {...s}
                    if(s.searchers && s.searchers instanceof Array) {
                        const _searcherDict = {}
                        s.searchers.forEach(searcher=>{
                            _searcherDict[searcher.id] = searcher
                        })
                        _s.searchers = _searcherDict
                    }
                    else {
                        _s.searchers = {}
                    }
                    subs[s.ctrl] = _s
                })
                return subs
            }
            return {}
        },
        marks() {
            let m = this.$store.getters.getModule(this.$route.meta.id)
            if(m && m.sub) {
                let marks = {}
                m.sub.forEach((s)=>{
                    marks[s.ctrl] = this.$store.getters.getMarks(parseInt(s.id))
                })
                return marks
            }
            return []
        },
        mark_permission() {
            return this.$store.state.game.info.mark
        },
        container_class() {
            return `container ${this.$route.name}`;
        }
    },
}
</script>

<style lang="less" scoped>
.fixed_module_container {
    .container {
        &.veteran {
            width: auto;
        }
        &.experience {
            width: auto
        }
    }
}
</style>